<template>
  <div class="o-mobib">
    <o-icon
      icon="chevron-right"
      class="o-mobib__toggle"
      :class="{
        'o-mobib__toggle--open': !isCollapsed
      }"
      @click.native="toggleCollapse"
    />
    <o-icon
      v-if="!isCollapsed"
      icon="minus"
      class="o-mobib__remove"
      @click.native="removeCard"
    />
    <o-section v-if="isCollapsed" @click.native="toggleCollapse">{{
      label
    }}</o-section>
    <template v-if="!isCollapsed">
      <o-section> <o-text-input label="Card Name" :value="label" /> </o-section>
      <o-section>
        <o-text-input label="Card Number" :value="cardNumber" />
      </o-section>
      <o-section>
        <o-text-input label="Serial Number" :value="serialNumber" />
      </o-section>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    collapsed: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    cardNumber: {
      type: String,
      default: ''
    },
    serialNumber: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isCollapsed: true
    }
  },

  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },

    removeCard() {
      if (window.confirm('Are you sure you want to remove this card?')) {
        this.isCollapsed = true
      }
    }
  },

  created() {
    this.isCollapsed = this.collapsed
  }
}
</script>

<style lang="scss">
.o-mobib {
  position: relative;
}

.o-mobib__toggle {
  cursor: pointer;
  position: absolute;
  right: 1.2rem;
  top: 1.2rem;
  z-index: 5;
}

.o-mobib__toggle--open {
  transform: rotate(90deg);
}

.o-mobib__remove {
  cursor: pointer;
  position: absolute;
  right: 4.8rem;
  top: 1.2rem;
  z-index: 5;
}
</style>
